import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'antd';
import { device, Colors, formValidateMessages, Modal, isMobile } from 'utils';

import PropTypes from 'prop-types';
import CurrencyInput from 'react-currency-input-field';
import styled from '@emotion/styled';
import DropDown from '../Dropdown/Dropdown';
import { connect } from 'react-redux';
import { InfoCircleOutlined } from '@ant-design/icons';
import '../../../../../utils/Payment';
import GoodiesAndTickets from '../GoodiesAndTickets/GoodiesAndTickets';
import CommonsplaceAddition from '../CommonsplaceAddition/CommonsplaceAddition';
import InfoTooltip from '../InfoTooltip/InfoTooltip';

const FormItem = Form.Item;

const Donation = ({
  showPaymentForm,
  donation,
  freiwilliges,
  showOption,
  otherOption,
  originalDonation,
  setDonationState,
  setCurrentViewState,
  setShowOptionState,
  setOtherOptionState,
  setFreiwilligesState,
  setShowPaymentFormState,
  handelShowModal,
  projectId,
  originalRewardId,
  isTicketable,
  selectedRewards,
  recurringCheck,
  embeddedAction,
  project_name,
  setAllRewards,
  setSelectedRewards,
  setAddressRequired,
  allRewards,
  formRef,
  handleCLientSecret,
  saveKey,
  saveDonation,
  project,
  supportLevelSelected,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [donationLessThenFive, setDonationLessThenFive] = useState(false);
  const [canChangeFeriwilliges, setCanChangeFeriwilliges] = useState(true);
  const [lastDonation, setLastDonation] = useState(0);
  const [selectedKey, setSelectedKey] = useState(
    project_name === 'freitag' ? 4 : 0
  );
  const [showGoodiesLimitModal, setShowGoodiesLimitModal] = useState(false);
  const [selectedSupportLevel, setSelectedSupportLevel] = useState();
  const [goodiesWithLimitReached, setGoodiesWithLimitReached] = useState([]);
  const [showAllSupportLevels, setShowAllSupportLevels] = useState(false);
  const [donationInputValue, setDonationInputValue] = useState(donation ?? '');
  const inputChangeRef = useRef(false);
  const supportLevels = Array.isArray(project?.support_levels)
    ? project.support_levels.sort((a, b) => Number(a.price) - Number(b.price))
    : [];
  console.log(
    supportLevels,
    project.donations_average,
    supportLevels.length === 0,
    project
  );

  const shouldShowSupportLevels = supportLevels.length > 0 && !isTicketable;
  const hasSelectedSupportLevel = Boolean(selectedSupportLevel);
  const hasSelectedTicket =
    isTicketable &&
    selectedRewards?.some((reward) => Number(reward?.quantity ?? 1) > 0);
  const shouldShowTipSelector = !isTicketable || hasSelectedTicket;

  const normalizeAmount = (value) => {
    if (value === undefined || value === null || value === '') return 0;

    if (typeof value === 'number') return value;

    return Number(String(value).replaceAll('.', '').replaceAll(',', '.')) || 0;
  };

  const formatEuro = (value) => {
    const number = normalizeAmount(value);

    return new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);
  };

  const handleSupportLevelClick = (level) => {
    const amount = normalizeAmount(level?.price);

    saveDonation(numberToString(amount));
    setDonationState(numberToString(amount));
    setDonationInputValue(numberToString(amount));
    setLastDonation(amount);
    setCanChangeFeriwilliges(true);
    setSelectedSupportLevel(level);

    const totalDonation = amount + Number(selectedRewardsPrice());

    setFreiwilligesState(numberToString(mapDonatiosToValue(totalDonation)));

    if (totalDonation > 0 && totalDonation < 5) {
      setDonationLessThenFive(true);
    } else {
      setDonationLessThenFive(false);
    }

    if (formRef?.current) {
      formRef.current.setFieldsValue({
        donation: numberToString(amount),
      });
      formRef.current.validateFields();
    }
    if (supportLevelSelected) {
      supportLevelSelected(level);
    }
  };

  const numberToString = (value) => parseFloat(value).toFixed(2);

  const handleSetSelectedKey = (key) => {
    setSelectedKey(key);
    saveKey(key);
  };

  useEffect(() => {
    if (inputChangeRef.current) {
      inputChangeRef.current = false;
      return;
    }

    setDonationInputValue(donation ?? '');
  }, [donation]);

  const mapDonatiosToValue = (value) => {
    let mappedValue;
    let donationValue;

    if (value && typeof value === 'string' && value.includes(',')) {
      const splitNumber = value.split(',');
      const decimalTens = splitNumber[1]
        ? parseFloat(splitNumber[1][0]) / 10
        : 0;
      const decimalHundreds =
        splitNumber[1] && splitNumber[1].length > 1
          ? parseFloat(splitNumber[1][1]) / 100
          : 0;
      const decimalNumber = decimalTens + decimalHundreds;
      donationValue = parseFloat(splitNumber[0]) + decimalNumber;
    } else {
      donationValue = value ? parseFloat(Number(value)) : 0;
    }

    switch (true) {
      case donationValue < 7:
        mappedValue = 1;
        break;
      case donationValue < 10:
        mappedValue = 1.5;
        break;
      case donationValue < 12:
        mappedValue = 2;
        break;
      case donationValue < 15:
        mappedValue = 2.5;
        break;
      case donationValue < 17:
        mappedValue = 3;
        break;
      case donationValue < 20:
        mappedValue = 3.5;
        break;
      case donationValue < 22:
        mappedValue = 4;
        break;
      case donationValue < 25:
        mappedValue = 4.5;
        break;
      case donationValue < 27:
        mappedValue = 5;
        break;
      case donationValue < 30:
        mappedValue = 5.5;
        break;
      case donationValue < 32:
        mappedValue = 6;
        break;
      case donationValue < 35:
        mappedValue = 6.5;
        break;
      case donationValue < 37:
        mappedValue = 7;
        break;
      case donationValue < 40:
        mappedValue = 7.5;
        break;
      case donationValue < 50:
        mappedValue = 8;
        break;
      case donationValue < 60:
        mappedValue = 9;
        break;
      case donationValue < 70:
        mappedValue = 10;
        break;
      case donationValue < 80:
        mappedValue = 11;
        break;
      case donationValue < 90:
        mappedValue = 12;
        break;
      case donationValue < 100:
        mappedValue = 13;
        break;
      case donationValue < 110:
        mappedValue = 14;
        break;
      case donationValue < 120:
        mappedValue = 15;
        break;
      case donationValue < 130:
        mappedValue = 16;
        break;
      case donationValue < 140:
        mappedValue = 17;
        break;
      case donationValue < 150:
        mappedValue = 18;
        break;
      case donationValue < 160:
        mappedValue = 19;
        break;
      case donationValue < 170:
        mappedValue = 20;
        break;
      case donationValue < 180:
        mappedValue = 21;
        break;
      case donationValue < 190:
        mappedValue = 22;
        break;
      case donationValue < 231:
        mappedValue = 23;
        break;
      default:
        mappedValue = donationValue / 10;
        break;
    }

    return mappedValue;
  };

  const handelCloseGoodiesLimitModal = () => {
    setShowGoodiesLimitModal(false);
    document.body.style.overflowY = 'unset';
  };

  const selectedRewardsPrice = () => {
    let totalPrice = 0;

    selectedRewards.forEach((reward) => {
      totalPrice += Number(reward.price) * Number(reward.quantity || 1);
    });

    return totalPrice;
  };

  const handleCheckRewardLimit = () => {
    const limitReachedGoodies = selectedRewards?.filter(
      (goodie) => goodie?.max_order_count === goodie?.ordered_reward_count
    );

    if (limitReachedGoodies.length > 0) {
      setShowGoodiesLimitModal(true);
      setGoodiesWithLimitReached(limitReachedGoodies);
    }
  };

  useEffect(() => {
    if (isTicketable && !hasSelectedTicket) {
      setFreiwilligesState(0);
      return;
    }

    setFreiwilligesState(numberToString(mapDonatiosToValue(donation)));
  }, []);

  useEffect(() => {
    if (isTicketable && !hasSelectedTicket) {
      setFreiwilligesState(0);
      setDonationLessThenFive(false);

      if (formRef?.current) {
        formRef.current.validateFields();
      }

      return;
    }

    const totalDonation = Number(donation) + selectedRewardsPrice();

    setFreiwilligesState(numberToString(mapDonatiosToValue(totalDonation)));

    if (totalDonation > 0 && totalDonation < 5) {
      setDonationLessThenFive(true);
    } else {
      setDonationLessThenFive(false);
    }

    if (formRef?.current) {
      formRef.current.validateFields();
    }

    handleCheckRewardLimit();
  }, [selectedRewards]);

  const totalPriceSum = parseFloat(
    Number(freiwilliges) + Number(selectedRewardsPrice()) + Number(donation)
  ).toFixed(2);

  const donationTypeOptions = [
    { label: 'Einmalig', key: 0 },
    { label: 'Täglich', key: 1 },
    { label: 'Wöchentlich', key: 2 },
    { label: 'Monatlich', key: 3 },
  ];

  const ramzanTypeOptions = [
    { label: 'Täglich', key: 0 },
    { label: 'Einmalig', key: 1 },
    { label: 'Wöchentlich', key: 2 },
    { label: 'Monatlich', key: 3 },
  ];

  const freitagTypeOptions = [
    { label: 'Wöchentlich Freitag', key: 4 },
    { label: 'Monatlicher Freitag', key: 5 },
  ];

  const totalRewardAmount = JSON.parse(localStorage.getItem('answers'))?.reduce(
    (prev, curre) =>
      prev + Number(curre.price || 0) * Number(curre.quantity || 1),
    0
  );

  const total =
    Number(localStorage.getItem('amount') || 0) +
    Number(localStorage.getItem('tips') || 0) +
    (totalRewardAmount || 0);

  const usedDonation = canChangeFeriwilliges
    ? Number(donation) + Number(selectedRewardsPrice())
    : Number(lastDonation) + Number(selectedRewardsPrice());

  const changeFreiwillings = (value) => {
    const hasValue = value !== undefined && value !== null && value !== '';
    const normalizedValue = hasValue ? normalizeAmount(value) : 0;
    const nextInputValue = hasValue ? value : '';

    inputChangeRef.current = true;
    setDonationInputValue(nextInputValue);
    saveDonation(nextInputValue);
    setSelectedSupportLevel(undefined);
    setShowAllSupportLevels(false);
    supportLevelSelected?.(null);

    const totalDonation = normalizedValue + Number(selectedRewardsPrice());

    const feriwilligesMapped = mapDonatiosToValue(totalDonation);

    if (totalDonation > 0 && totalDonation < 5) {
      setDonationLessThenFive(true);
    } else {
      setDonationLessThenFive(false);
    }

    setDonationState(hasValue ? numberToString(normalizedValue) : '');
  };

  const searchParams = new URLSearchParams(document.location.search);
  const payment_id = searchParams.get('paymentId');
  const payment_intent = searchParams.get('payment_intent');

  const handleShowAllSupportLevels = () => {
    setShowAllSupportLevels(true);
    setSelectedSupportLevel(undefined);

    if (supportLevelSelected) {
      supportLevelSelected(null);
    }
  };

  const handleChangeSupportLevelAmount = () => {
    setSelectedSupportLevel(undefined);
    setShowAllSupportLevels(true);

    if (supportLevelSelected) {
      supportLevelSelected(null);
    }
  };

  const renderSupportLevels = () => {
    const maxSupportLevelsToShow = 5;
    const visibleSupportLevels = selectedSupportLevel
      ? [selectedSupportLevel]
      : showAllSupportLevels
      ? supportLevels
      : supportLevels.slice(0, maxSupportLevelsToShow);
    return (
      <SupportLevelsSection>
        {!hasSelectedSupportLevel && (
          <PickItOrNotText>Oder wähle eine Unterstützungsstufe</PickItOrNotText>
        )}
        {visibleSupportLevels.map((level, index) => (
          <SupportLevelCard
            className={
              selectedSupportLevel === level
                ? 'active'
                : ''
            }
            key={`${level?.title || 'support-level'}-${index}`}
            type="button"
            onClick={() => handleSupportLevelClick(level)}
          >
            <SupportLevelPrice>{formatEuro(level?.price)} €</SupportLevelPrice>

            <SupportLevelContent>
              <SupportLevelTitle>
                {level?.title || 'Unterstützungsstufe'}
              </SupportLevelTitle>

              {level?.description && (
                <SupportLevelDescription>
                  {level.description}
                </SupportLevelDescription>
              )}
              <SupportLevelBookedText>
                {level.booked} mal gebucht
              </SupportLevelBookedText>
            </SupportLevelContent>
          </SupportLevelCard>
        ))}
        {selectedSupportLevel && (
          <ShowAllSupportLevelsButton
            type="button"
            onClick={handleChangeSupportLevelAmount}
          >
            Betrag ändern
          </ShowAllSupportLevelsButton>
        )}
        {!selectedSupportLevel &&
          !showAllSupportLevels &&
          supportLevels.length > maxSupportLevelsToShow && (
            <ShowAllSupportLevelsButton
              type="button"
              onClick={handleShowAllSupportLevels}
            >
              Alle anzeigen
            </ShowAllSupportLevelsButton>
          )}
        {!selectedSupportLevel &&
          showAllSupportLevels &&
          supportLevels.length > maxSupportLevelsToShow && (
            <ShowAllSupportLevelsButton
              type="button"
              onClick={() => setShowAllSupportLevels(false)}
            >
              Wieder ausblenden
            </ShowAllSupportLevelsButton>
          )}
      </SupportLevelsSection>
    );
  };

  return (
    <>
      <DonationWrapper donationLessThenFive={donationLessThenFive}>
        <Form
          validateMessages={formValidateMessages}
          ref={formRef}
          initialValues={{
            donation,
            freiwilliges,
          }}
          scrollToFirstError
        >
          <LeftColumnContent>
            {!isTicketable && (
              <Section>
                {!hasSelectedSupportLevel && (
                  <>
                    {isMobile() ? (
                      <LabelAmount>
                        {selectedRewards
                          ? project_name === 'ramadan2026'
                            ? 'Deine tägliche Unterstützung'
                            : 'Deine Unterstützung'
                          : 'Unterstützung'}
                      </LabelAmount>
                    ) : (
                      ''
                    )}
                    <FormItem
                      name="donation"
                      label={
                        !isMobile()
                          ? selectedRewards
                            ? project_name === 'ramadan2026'
                              ? 'Deine tägliche Unterstützung'
                              : 'Deine Unterstützung'
                            : 'Unterstützung'
                          : ''
                      }
                      className="new-donation-input donation-input-failed"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      rules={[
                        () => ({
                          validator() {
                            const currentDonation = normalizeAmount(
                              formRef?.current?.getFieldValue('donation')
                            );
                            const rewardsPrice = Number(selectedRewardsPrice());
                            const totalDonation =
                              currentDonation + rewardsPrice;

                            if (totalDonation === 0) {
                              return Promise.resolve();
                            }

                            if (totalDonation >= 5) {
                              return Promise.resolve();
                            }

                            return Promise.reject(
                              new Error('Der Mindestgesamtbetrag beträgt 5 €')
                            );
                          },
                        }),
                      ]}
                    >
                      <DonationAmountBox>
                        <CurrencyInput
                          allowNegativeValue={false}
                          decimalSeparator=","
                          groupSeparator="."
                          placeholder="0,00"
                          // defaultValue={
                          //   payment_id == undefined ||
                          //   payment_intent == undefined
                          //     ? donation
                          //     : Number(localStorage.getItem('amount')).toFixed(
                          //         2
                          //       )
                          // }
                          onFocus={(e) => e.target.select()}
                          value={donationInputValue}
                          onValueChange={(value) => changeFreiwillings(value)}
                          disabled={isTicketable}
                          className="new-currency-input"
                        />
                        <CurrencySymbol>€</CurrencySymbol>
                      </DonationAmountBox>
                    </FormItem>

                    {supportLevels.length === 0 &&
                    project.donations_average &&
                    Number(project.donations_average.replace(',', '.')) > 0 ? (
                      <DonationHint>
                        Dieses Projekt erhält im Schnitt{' '}
                        <strong style={{ color: '#3F621A' }}>
                          Ø {project.donations_average} €
                        </strong>{' '}
                        Unterstützung aus der Community.
                      </DonationHint>
                    ) : (
                      ''
                    )}
                  </>
                )}

                {shouldShowSupportLevels && renderSupportLevels()}

                {recurringCheck && (
                  <FieldBlock
                    style={{ width: '100%' }}
                    className={`${
                      (project_name === 'ramadan2025' ||
                        project_name === 'ramadan2026') &&
                      'hide-Rhythmus'
                    }`}
                  >
                    <FieldLabelRow>
                      <FieldLabel>Rhythmus</FieldLabel>

                      <InfoTooltip text="Wiederkehrende Unterstützungen können jederzeit per E-Mail an salam@commonsplace.de oder direkt im Nutzerprofil beendet werden." />
                    </FieldLabelRow>

                    <DropDown
                      setSelectedKey={handleSetSelectedKey}
                      options={
                        project_name === 'freitag'
                          ? freitagTypeOptions
                          : project_name
                          ? ramzanTypeOptions
                          : donationTypeOptions
                      }
                    />
                  </FieldBlock>
                )}
              </Section>
            )}

            <GoodiesAndTickets
              recurringCheck={recurringCheck}
              isTicketable={isTicketable}
              projectId={projectId}
              originalRewardId={originalRewardId}
              donationLessThenFive={donationLessThenFive}
              setAllRewards={setAllRewards}
              setSelectedRewards={setSelectedRewards}
              setAddressRequired={setAddressRequired}
              allRewards={allRewards}
              selectedRewards={selectedRewards}
              handleCLientSecret={handleCLientSecret}
              formRef={formRef}
            />

            {shouldShowTipSelector && (
              <CommonsplaceAddition
                usedDonation={usedDonation}
                setFreiwilligesState={setFreiwilligesState}
                defaultTip={mapDonatiosToValue(usedDonation)}
              />
            )}
          </LeftColumnContent>
        </Form>
      </DonationWrapper>

      <Modal
        showModal={showGoodiesLimitModal}
        handelCloseModal={handelCloseGoodiesLimitModal}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <h1 style={{ color: '#95bd51' }}>Goodies</h1>
          {goodiesWithLimitReached?.map((goodie) => (
            <p key={goodie?.id || goodie?.title}>Goodie: {goodie?.title}</p>
          ))}
          {isTicketable ? (
            <p>Ticket Limit erreicht</p>
          ) : (
            <p>Maximales Goodies-Limit erreicht!</p>
          )}
        </div>
      </Modal>
    </>
  );
};

Donation.propTypes = {
  showPaymentForm: PropTypes.bool.isRequired,
  donation: PropTypes.any.isRequired,
  freiwilliges: PropTypes.any.isRequired,
  showOption: PropTypes.bool.isRequired,
  otherOption: PropTypes.bool.isRequired,
  originalDonation: PropTypes.number.isRequired,
  setDonationState: PropTypes.func.isRequired,
  setCurrentViewState: PropTypes.func.isRequired,
  setShowOptionState: PropTypes.func.isRequired,
  setOtherOptionState: PropTypes.func.isRequired,
  setFreiwilligesState: PropTypes.func.isRequired,
  setShowPaymentFormState: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
  originalRewardId: PropTypes.number.isRequired,
  setAllRewards: PropTypes.func.isRequired,
  setSelectedRewards: PropTypes.func.isRequired,
  setAddressRequired: PropTypes.func.isRequired,
  allRewards: PropTypes.any.isRequired,
  selectedRewards: PropTypes.any.isRequired,
  formRef: PropTypes.object.isRequired,
  handleCLientSecret: PropTypes.func.isRequired,
  handelShowModal: PropTypes.any.isRequired,
  isTicketable: PropTypes.bool.isRequired,
  embeddedAction: PropTypes.bool,
  project_name: PropTypes.string,
  saveKey: PropTypes.func.isRequired,
  saveDonation: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    donationType: state.donationType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveKey: (key) => dispatch({ type: 'SAVE_KEY', payload: key }),
    saveDonation: (amount) =>
      dispatch({ type: 'SAVE_AMOUNT', payload: amount }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Donation);
const LeftColumnContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const DonationAmountBox = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 64px;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #d5d7da;
  border-radius: 10px;
`;

const CurrencySymbol = styled.span`
  flex-shrink: 0;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 32px;
  line-height: 40px;
  color: #6e6e6e;
  padding-left: 12px;
`;

const DonationHint = styled.p`
  margin: -8px 0 0;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #656565;
`;

const FieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 320px;

  @media ${device.allMobile} {
    width: 100%;
  }
`;

const FieldLabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const FieldLabel = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
`;

const TipCardSection = styled.section`
  box-sizing: border-box;
  width: 100%;
  background: #f5fbee;
  border: 1px solid #d5d7da;
  border-radius: 8px;
  padding: 24px;
  margin-top: 12px;
`;

const SummarySection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SummaryTitle = styled.h3`
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
`;

const SummaryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: #414651;

  &.total {
    color: #181d27;
    font-size: 18px;
  }
`;

const SummaryDivider = styled.div`
  width: 100%;
  height: 1px;
  background: #d5d7da;
`;

const SupportLevelsSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

const SupportLevelCard = styled.button`
  box-sizing: border-box;
  width: 100%;
  min-width: 320px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    border-color: #9dbc60;
    box-shadow: 0 8px 20px rgba(16, 24, 40, 0.08);
    transform: translateY(-1px);
  }

  &:focus {
    outline: none;
    border-color: #9dbc60;
    box-shadow: 0 0 0 3px rgba(157, 188, 96, 0.22);
  }

  &.active {
    border-color: #9dbc60;

    box-shadow: 0 0 0 3px rgba(157, 188, 96, 0.18);
  }

  @media ${device.allMobile} {
    min-width: 0;
  }
`;

const SupportLevelPrice = styled.div`
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #181d27;
`;

const SupportLevelContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
`;
const SupportLevelTitle = styled.div`
  width: 100%;

  font-family: 'Inter', sans-serif;

  font-style: normal;

  font-weight: 600;

  font-size: 16px;

  line-height: 24px;

  color: #181d27;

  overflow-wrap: break-word;

  word-break: break-word;
`;

const SupportLevelDescription = styled.div`
  width: 100%;

  font-family: 'Inter', sans-serif;

  font-style: normal;

  font-weight: 400;

  font-size: 14px;

  line-height: 20px;

  color: #656565;

  overflow-wrap: break-word;

  word-break: break-word;
`;

const SupportLevelBookedText = styled.div`
  width: 100%;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #656565;
`;

const ShowAllSupportLevelsButton = styled.button`
  width: 100%;
  border: none;
  background: transparent;
  padding: 0;
  font-family: 'Helvetica', Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  text-align: center;
  text-decoration-line: underline;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
`;

const DonationWrapper = styled.div`
  .hide-Rhythmus {
    display: none;
  }

  .currency-input {
    margin: 0;

    input,
    button {
      padding-right: 20px !important;
    }

    &::after {
      width: 20px;
      border: none;
      background: none;
      line-height: 34px;

      @media ${device.tablet} {
        line-height: 25px;
      }

      @media ${device.allMobile} {
        line-height: 25px;
      }
    }
  }

  .donation-input-failed {
    label {
      color: ${(props) => props.donationLessThenFive && `${Colors.red}`};
    }
  }

  .primary-button {
    @media ${device.laptop} {
      padding: 15px 14px;
    }

    @media ${device.allMobile} {
      padding: 5px 7px;
      font-size: 14px;
      border-radius: 5px;
      display: flex !important;
      flex-direction: row !important;
    }

    @media ${device.tablet} {
      padding: 5px 7px;
      font-size: 14px;
      border-radius: 5px;
    }
  }

  .feriwill-button {
    font-weight: bold;
    color: black;
    border: 1px solid black;
    border-radius: 10px;
    font-size: 24px;
    padding: 10px;
    text-align: right;
    max-width: 100px;
    background: none;
    width: 100%;

    @media ${device.allMobile} {
      font-size: 16px;
    }
  }

  .feriwill-button:hover {
    color: #95bd51;
    border-color: #95bd51;
  }

  .ant-form-item-explain.ant-form-item-explain-error {
    font-size: 14px;

    @media ${device.tablet} {
      font-size: 12px;
    }
  }

  .small-font {
    font-size: 0.9rem;

    @media ${device.allMobile} {
      display: block;
    }
  }

  .tip-btn {
    &:hover {
      background: #95bd51;
      color: #000;
    }
  }

  .text-setting {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media screen and (max-width: 425px) {
    .donation-input .ant-form-item-label {
      font-size: 14px !important;
    }

    .text-setting {
      display: flex;
    }

    .label-blk {
      .ant-form-item-label {
        label {
          width: 100% !important;
        }
      }

      .ant-form-item-control {
        width: 100% !important;
        max-width: 100% !important;

        @media (max-width: 575px) {
          flex: 0 0 50% !important;
        }
      }
    }

    .donation-input-failedd {
      display: flex !important;
      flex-direction: column;
      width: 100%;
    }
  }

  .donation-override .ant-form-item-control {
    @media (min-width: 1201px) {
      max-width: 250px !important;
    }

    @media (max-width: 1200px) and (min-width: 1000px) {
      max-width: 220px !important;
    }

    @media (max-width: 999px) and (min-width: 950px) {
      max-width: 120px !important;
    }

    @media (max-width: 820px) and (min-width: 767px) {
      max-width: 96px !important;
    }
  }

  .gesamtsumme-container {
    width: 100%;
    padding-bottom: 16px;
  }

  .gesamtsumme-title {
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    margin-bottom: 12px;
  }

  .gesamtsumme {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .summary-item {
    display: flex;
    justify-content: space-between;
    font-size: 18px;
  }

  .summary-label {
    font-weight: bold;
  }

  .summary-value {
    font-weight: normal;
  }

  .no-line-breaks {
    white-space: nowrap;
  }

  .summary-divider {
    border: none;
    height: 1px;
    background: #ccc;
    margin: 12px 0;
  }

  .summary-total {
    font-size: 18px;
    font-weight: bold;
  }

  .ant-row,
  .ant-form-item-row {
    max-width: 100% !important;
  }

  .new-donation-input {
    display: flex;
    flex-direction: column;
    font-weight: bold;
    margin-bottom: 0 !important;

    label {
      font-size: 18px !important;
    }
  }

  .new-currency-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: ${(props) =>
      props.donationLessThenFive
        ? `1px solid ${Colors.red}`
        : `1px solid #DCDCDC`} !important;
    border-radius: 10px;
    padding: 8px;
    max-width: 100% !important;
    min-height: 64px;
    height: 64px;
  }

  .new-currency-input {
    flex: 1;
    border: none;
    outline: none;
    font-size: 32px;
    text-align: left;
    font-weight: bold;
    padding-left: 20px;
    min-width: 0;
    max-width: 100%;
    max-height: 58px;
  }

  .new-currency-symbol {
    font-size: 32px;
    font-weight: normal !important;
    color: #6e6e6e;
    padding-right: 20px;
    flex-shrink: 0;
  }

  .freiwilliges-input-wrapper {
    padding-top: 24px;
    padding-bottom: 24px;
    margin-bottom: 24px;
  }
`;

const LabelAmount = styled.div`
  /* Label */
  /* Text sm/Medium */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */
  margin-bottom: -16px;
  margin-top: 16px;
  color: #414651;
`;

const PickItOrNotText = styled.div`
  /* Text sm/Medium */
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  color: #414651;
`;
